// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"42":"25c625140e1884d29d10","702":"83e63b16c6c1c616ff02","715":"29cde7d61e686df1e337","934":"c11a0f311ed8a69d7824"}[chunkId] + ".css";
};